import { useTranslation } from 'react-i18next';
import { useReveal } from '@/shared/hooks/useReveal';
import { CheckIcon } from '@/shared/components/Icons';
import styles from './About.module.css';

export function About() {
  const { t } = useTranslation();
  const ref = useReveal();

  const points = ['about.point1', 'about.point2', 'about.point3'];

  return (
    <section id="enfoque" className={styles.section}>
      <div className={`container ${styles.grid}`}>
        <div className={`${styles.media} reveal`} ref={ref}>
          <img
            src="/img/cover.jpg"
            alt={t('about.title')}
            loading="lazy"
            width={1440}
            height={810}
          />
        </div>

        <div className={styles.content}>
          <span className="eyebrow">{t('nav.about')}</span>
          <h2>{t('about.title')}</h2>
          <p className={`lead ${styles.body}`}>{t('about.body')}</p>
          <ul className={styles.list}>
            {points.map((p) => (
              <li key={p}>
                <CheckIcon width={20} height={20} className={styles.check} />
                {t(p)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
